/*
    Make sure the value of certain keys under user state object is always correct
    (according to the CMus cookie)
 */
define('shared/util/state/adapters/user',[
    'shared/lib/RSVP',
    'shared/remote/member/get'
], 
function ( RSVP, getMember ) {
    
    var USER = 'user';
    var PROP_MEMBER = {
        'username': 'UserName',
        'member_type': 'MemberType',
        'member_id': 'Member_id',
        'partner': 'PartnerCode'
    };
    var undef;


    var adapter = {

        'isApplicable' : function (key) {
            return key && (key.split('.')[0] === USER);
        },

        'beforeGet' : function (state, key) {
            var keys = key.split('.');
            var subKey = keys[1];
            var remoteKey = PROP_MEMBER[subKey];

            if ( subKey == null ||  subKey == '' || remoteKey == null ) {
                return;
            }

            return getMember()
                .then(function(member){
                    return state.put( key, member == null ? undef : member[remoteKey] );
                });
        }
    };

    return adapter;
});

